<template>
    <data-dialog 
        :dialog-title="lsDialog.title" 
        :is-visible="lsDialog.lsJsFormVisible" 
        :is-read="true"
        @dgVerifyDeal="dgVerifyDeal2('lsJsDialog','lsJsForm')" 
        ref="lsJsDialog"
        @dgConfirmDeal="dgLsJsConfirmDeal"
        @dgCancelDeal="dgCancelDeal"
        :isOwnStyle="true"
        :dgStyle="xxxx"
    >
        <div slot="dialogFrom">
            <el-form ref="lsJsForm" :model="jsData" :rules="lsJsRules" label-width="100px" :disabled="false"
                    label-position="top" class="commonForm">
                <el-row>
                    <el-col :span="24">
                        <el-form-item prop="rz" style="width: 70%;margin: 20px auto 0;">
                            <el-input v-model="jsData.rz" clearable placeholder="请输入水位(m)"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <div style="width: 70%;margin: 20px auto 0;">
                            <el-button type="primary" size="small" @click="lsJsDeal" style="width: 100%;height: 50px;font-size: 16px;">计算流量</el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item prop="q">
                            <div style="width: 70%;margin: 20px auto 0;height: 110px;border: 2px solid #f2b145;background-color: #fef8ec;border-radius: 5px;font-size: 16px;">
                                <div style="text-align: center;height: 50px;line-height: 50px;">流量</div>
                                <div style="height: 50px;line-height: 50px;background-color: #fff;width: 90%;margin: 0 auto;text-align: center;color: #ee7e32;font-weight: 700;">
                                    {{ jsData.q }}
                                    <span v-if="jsData.q">(m³/s)</span>
                                </div>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </data-dialog>
</template>
<script>
import DataDialog from "@/components/tableGather/dataDialog";
export default {
    components: {
        DataDialog,
    },
    props:{
        lsDialog:{
            type:Object
        },
        stcd:{
            type:String
        },
    },
    data() {
        let validateRealNum = (rule, value, callback) => {
            if (value == null || value.length == 0) {
                callback();
            } else {
                let reg = /^[-+]?[0-9]*\.?[0-9]+$/;
                if (reg.test(value)) {
                    let zs = (value + '').split('.')[0];
                    if (zs.length > 6) {
                        return callback(new Error("该数据最多6位"));
                    }
                    callback();
                } else {
                    return callback(new Error("只能输入数值"));
                }
            }
        };
        return {
            loading:false,
            jsData:{
                rz:'',
                q:'',
            },
            lsJsRules: {
                rz: [
                    {required: true, message: "请输入水位", trigger: 'blur'},
                    {validator: validateRealNum, trigger: 'blur'},
                ],
            },
            xxxx:{
                height: '45%',
                width: '30%',
            }
        };
    },
    methods:{
        dgVerifyDeal2(dgRef, frRef) {
            this.$refs[frRef].validate((valid) => {
                if (valid) {
                this.$refs[dgRef].isShowPop(true);
                } else {
                this.$refs[dgRef].isShowPop(false);
                }
            });
        },
        dgLsJsConfirmDeal() {
            this.addLsData();
        },
        dgCancelDeal() {
            if (this.lsDialog.lsJsFormVisible) {
                this.lsDialog.lsJsFormVisible = false;
                this.$refs.lsJsForm.resetFields();
                this.$refs.lsJsForm.clearValidate();
            }
        },
        lsJsDeal() {
            this.$refs.lsJsForm.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    let params = {
                        rz: this.jsData['rz'],
                        stcd: this.stcd,
                    }
                    this.request.get('/rm-brcurve/calcQ',{params: params}).then(res => {
                        if (res.ok) {
                            this.$set(this.jsData,'q',res.data);
                        } else {
                            this.$message.error(res.error.message);
                        }
                        this.loading = false;
                    });
                }
            });
        },
    },
}
</script>

<style scoped>
::v-deep .el-dialog {
    overflow: hidden !important;
    margin-top: 0px !important;
}
::v-deep .el-dialog__header {
    display: block !important;
    height: 6vh;
    line-height: 6vh;
    padding: 0;
    background-color: #F0EFEF;
    position: relative;
}
::v-deep .el-dialog__footer {
    display: block !important;
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
}

::v-deep .el-dialog__headerbtn {
    position: absolute;
    top: 0px;
    right: 10px;
    height: 5vh;
    line-height: 5vh;
}

::v-deep .el-dialog__body {
    padding: 10px 20px 0px 20px !important;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    position: absolute;
    left: 0;
    top: 6vh;
    bottom: 70px;
    right: 0;
    overflow: auto;
}

::v-deep .dialog-footer {
    display: flex !important;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #fff;
    width: 100%;
    height: 70px;
    z-index: 10;
    justify-content: flex-end;
    align-items: Center;
    box-sizing: border-box;
    padding-right: 20px;
}
::v-deep .el-input__inner {
    height: 50px;
    line-height: 50px;
    font-size: 16px;
}
</style>
